import React from 'react';
import PropTypes from 'prop-types';
import { Block } from '@webfox-sc/core';
import './assets-wrapper.scss';

const AssetsWrapper = ({ children }) => {
  return <Block className="bt-assets-wrapper">{children}</Block>;
};

AssetsWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AssetsWrapper;
